import { type Dispatch } from "redux";
import DataService from "../../services/videoDataService";
import {
  reqEngagementFunnelData,
  reqEngagementLineData,
  reqEngagementPeopleData,
  setEngagementError,
  setEngagementFunnelData,
  setEngagementFunnelError,
  setEngagementLineData,
  setEngagementPeopleData,
  setEngagementPeopleError,
} from "../slices/videoPerformanceSlice";
import { getAxiosError } from "../../../../../utils/axiosError";
import {
  type BasePerformanceRequestFilterParams,
  type VideoPerformanceRequestFilterParams,
} from "../../../Common/models";
import { sendExportRequest } from "../../../Common/utils/performanceUtils";
import { mockEmptyVideoEngagementData } from "../../types/mocks";

export const fetchEngagementLineData = (videoId: number, filterParams: VideoPerformanceRequestFilterParams = {}) => {
  return async (dispatch: Dispatch) => {
    dispatch(reqEngagementLineData());
    try {
      const data = await DataService.getVideoEngagement(videoId, filterParams);

      dispatch(
        setEngagementLineData({
          data,
        }),
      );
    } catch (err) {
      if (err.code === "ERR_CANCELED") {
        dispatch(reqEngagementLineData());
      } else {
        const errorMessage = getAxiosError(err);
        dispatch(setEngagementError({ errorMessage }));
      }
    }
  };
};

export const fetchEngagementFunnelData = (videoId: number, filterParams: VideoPerformanceRequestFilterParams = {}) => {
  return async (dispatch: Dispatch) => {
    dispatch(reqEngagementFunnelData());
    try {
      let data = await DataService.getVideoEngagementFunnel(videoId, filterParams);
      data = {
        ...mockEmptyVideoEngagementData,
        ...data,
      };

      dispatch(
        setEngagementFunnelData({
          data,
        }),
      );
    } catch (err) {
      if (err.code === "ERR_CANCELED") {
        dispatch(reqEngagementFunnelData());
      } else {
        const errorMessage = getAxiosError(err);
        dispatch(setEngagementFunnelError({ errorMessage }));
      }
    }
  };
};

export const fetchEngagementPeopleData = (videoId: number, filterParams: VideoPerformanceRequestFilterParams = {}) => {
  return async (dispatch: Dispatch) => {
    dispatch(reqEngagementPeopleData());
    try {
      let data = await DataService.getVideoEngagementPeople(videoId, filterParams);

      dispatch(
        setEngagementPeopleData({
          data,
        }),
      );
    } catch (err) {
      if (err.code === "ERR_CANCELED") {
        dispatch(reqEngagementPeopleData());
      } else {
        const errorMessage = getAxiosError(err);
        dispatch(setEngagementPeopleError({ errorMessage }));
      }
    }
  };
};

export const doExport = (videoId: number, filterParams: BasePerformanceRequestFilterParams, videoTitle: string) => {
  let abortController = new AbortController();
  return sendExportRequest(
    (abortController) => DataService.getExport(videoId, filterParams),
    videoTitle,
    abortController,
  );
};
